import React, { Component } from "react";
import { Route } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import banner_img from "../../images/banner-profile.jpg";
import { API_TOKEN_NAME, IMAGE_URL, SITE_URL } from "../../constants";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app

const getSingleGallery = (slug) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/album/getalbum/" + slug, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

class PhotoGalleryInner extends Component {
  state = {
    gallery: [],
    album_pics: [],
    photoIndex: 0,
    isOpen: false,
  };
  refreshSingleGallery = (event) => {
    let slug = this.props.match.params["slug"];
    
    getSingleGallery(slug)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          this.setState({ gallery: records });
          this.setState({
            album_pics: JSON.parse(this.state.gallery.album_pics),
          });
        } else {
          this.setState({ gallery: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    this.refreshSingleGallery();
  }

  render() {
    let slug = this.props.match.params["slug"];
    const { photoIndex, isOpen, album_pics } = this.state;
    return (
      <div>
        <SEO
          title={
            "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh"
          }
          description={"Photo Gallery of United Hospital Bangladesh Limited"}
          pathSlug="/gallery/photo-gallery"
          keywords="newsevents, Singlenewsevents"
        />
        <Helmet>
          <meta
            name="description"
            content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "LocalBusiness",
              name: "United Hospital Limited",
              image:
                "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
              telephone: "10666",
              email: "info@uhlbd.com",
              address: {
                "@type": "PostalAddress",
                streetAddress: "plot 15, Road 71, Gulshan",
                addressLocality: "Dhaka",
                addressRegion: "Dhaka",
                addressCountry: "Bangladesh",
                postalCode: "1212",
              },
              openingHoursSpecification: {
                "@type": "OpeningHoursSpecification",
                opens:
                  "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
              },
              url: "http://www.uhlbd.com/",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
                ratingCount: "756",
              },
              review: {
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "abdul kahar",
                },
                datePublished: "2019-02-12",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "3.9",
                  bestRating: "5",
                  worstRating: "1",
                },
                reviewBody:
                  "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
              },
            })}
          </script>
          <meta
            name="Subject"
            content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
          />
          <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
          <meta name="Googlebot" content="all" />
          <meta http-equiv="imagetoolbar" content="no" />
          <meta name="robots" content="index, follow" />
          <meta name="copyright" content="Copyright &copy; uhlbd.com" />
          <meta name="owner" content="United Hospital" />
          <meta name="author" content="dcastalia.com" />
          <meta name="Rating" content="General" />
          <meta name="distribution" content="Global" />
          <meta
            name="classification"
            content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta
            names="apple-mobile-web-app-status-bar-style"
            content="black-translucent"
          />
          <meta
            name="msvalidate.01"
            content="16C4E0B16E39354E550F64BD707F6A97"
          />
        </Helmet>
        <Route component={Header} />
        <div id="giveMarginService" className="" style={{ backgroundColor: "#fef3e9" }}>
          <section className="prof-dr">
            <div className="container ">
              <div className="box-of-about mt-4 pb-4">
                <div className="row">
                  <div className="col-md-4 w-100">
                    <div className="text-profile">
                      {/* <h2>{this.state.gallery.album_name}</h2>
										<p className="text-chnage" dangerouslySetInnerHTML={{ __html: this.state.gallery.album_desc }}></p>*/}
                      {this.state.album_pics.map((album_pic) => {
                        
                        return [
                          <img
                            src={IMAGE_URL + "AlbumImg/" + album_pic}
                            onClick={() => this.setState({ isOpen: true })}
                            style={{
                              width: "80vw",
                              maxWidth: "256px",
                              height: "144px",
                            }}
                          />,
                        ];
                      })}
                      {isOpen && (
                        <Lightbox
                          mainSrc={
                            IMAGE_URL + "AlbumImg/" + album_pics[photoIndex]
                          }
                          nextSrc={
                            IMAGE_URL +
                            "AlbumImg/" +
                            album_pics[(photoIndex + 1) % album_pics.length]
                          }
                          prevSrc={
                            IMAGE_URL +
                            "AlbumImg/" +
                            album_pics[
                              (photoIndex + album_pics.length - 1) %
                                album_pics.length
                            ]
                          }
                          onCloseRequest={() =>
                            this.setState({ isOpen: false })
                          }
                          onMovePrevRequest={() =>
                            this.setState({
                              photoIndex:
                                (photoIndex + album_pics.length - 1) %
                                album_pics.length,
                            })
                          }
                          onMoveNextRequest={() =>
                            this.setState({
                              photoIndex: (photoIndex + 1) % album_pics.length,
                            })
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Route component={Footer} />
      </div>
    );
  }
}
export default PhotoGalleryInner;



// WEBPACK FOOTER //
// ./src/component/frontend/PhotoGalleryInner.js